<template>
  <div class="templates-status">
    <div class="templates-status__label">
      <!-- confirmed -->
      <template v-if="syncStatus === 'synced'">
        <AppIcon icon="far fa-check" />
        <span>Guardado!</span>
      </template>
      <!-- saving -->
      <template v-else-if="syncStatus === 'saving'">
        <AppSpinner spinner="spring-spinner" color="var(--c-secondary-700)" :size="16" />
        <span>Guardando...</span>
      </template>
      <!-- error -->
      <template v-else-if="syncStatus === 'error'">
        <AppIcon icon="far fa-exclamation-circle" />
        <span>Error al guardar</span>
      </template>
      <!-- last saved on -->
      <template v-else>
        <AppIcon icon="far fa-sync" />
        <span> {{ lastModifiedMessage() }} </span>
      </template>
    </div>
    <!-- tooltip -->
    <AppTooltip v-if="showInfo" position="bottom" :message="statusMessage" />
  </div>
</template>

<script>
// Utilities
import { getTimeType, formatDate } from 'Utils'
import { statusInfo } from 'Modules/Templates/settings'
// Components
import AppIcon from 'Ui/AppIcon'
import AppSpinner from 'Ui/AppSpinner'
import AppTooltip from 'Ui/AppTooltip'

export default {
  name: 'TemplatesStatusControl',

  components: {
    AppIcon,
    AppSpinner,
    AppTooltip,
  },

  props: {
    template: {
      type: Object,
      required: true,
    },

    showInfo: {
      type: Boolean,
      default: true,
    },

    shortMessages: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      interval: null,
      lastModified: null,
    }
  },

  methods: {
    getModifiedTime() {
      this.lastModified = getTimeType(this.template.modified)
    },
  },

  computed: {
    syncStatus() {
      return this.$store.state.templates.syncStatus
    },

    statusMessage() {
      return this.mainIsPublished ? statusInfo.publishedMessage : statusInfo.draftMessage
    },

    mainIsPublished() {
      return !this.template.main && this.template.status === 'draft'
    },

    lastModifiedMessage() {
      let message = !this.lastModified?.passedDate
        ? 'Última modificación '
        : 'Última modificación el '
      return () => {
        let result = !this.shortMessages ? message : ''

        // DAYS
        if (this.lastModified?.passedDate) {
          return `${result}${formatDate(this.lastModified.passedDate)}`
        } else if (this.lastModified.hours) {
          // HOURS
          if (this.lastModified.hours === 1) {
            return `${result}hace una hora`
          } else {
            return `${result}hace ${this.lastModified.hours} horas`
          }
        } else {
          // MINUTES
          if (this.lastModified.minutes > 1) {
            return `${result}hace ${this.lastModified.minutes} minutos`
          } else if (this.lastModified.minutes === 1) {
            return `${result}hace ${this.lastModified.minutes} minuto`
            // SECONDS
          } else if (this.lastModified.minutes < 1) {
            return `${result}hace unos segundos`
          }
        }
      }
    },
  },

  watch: {
    // We watch for modifications and if it's the case, re-run the getModifiedTime function
    syncStatus(newValue) {
      newValue && this.getModifiedTime()
    },
  },

  created() {
    this.getModifiedTime()
    this.interval = setInterval(() => {
      this.getModifiedTime()
    }, 30000)
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },
}
</script>

<style scoped>
.templates-status {
  display: flex;
  margin-left: 40px;
}

.templates-status__label {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 5px;
  align-items: center;
  justify-content: space-between;
}

.templates-status__label span {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: var(--c-secondary-700);
  text-decoration: underline;
}

.templates-status__label .app-icon {
  font-size: 13px;
  color: var(--c-secondary-700);
}

.templates-status .diy-tooltip {
  position: relative;
  top: -8px;
  right: -3px;
}
</style>
